var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.089 14.4422V18.8822C19.0888 19.5104 18.8391 20.1128 18.3949 20.557C17.9507 21.0013 17.3483 21.2509 16.72 21.2512H5.11904C4.8068 21.2511 4.49765 21.1892 4.20938 21.0693C3.9211 20.9493 3.65937 20.7735 3.43923 20.5521C3.21909 20.3307 3.04488 20.0679 2.92661 19.7789C2.80833 19.4899 2.74833 19.1804 2.75004 18.8682V7.2802C2.74818 6.96845 2.80822 6.65943 2.92666 6.37104C3.04511 6.08266 3.21961 5.82066 3.44006 5.60021C3.6605 5.37977 3.92251 5.20526 4.21089 5.08682C4.49927 4.96837 4.80829 4.90834 5.12004 4.9102H9.55904",
    stroke: "#0075E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0909 8.9957L15.0059 4.9097M6.83594 15.8037V13.6387C6.83794 13.2817 6.97994 12.9387 7.23094 12.6857L16.7629 3.1537C16.8894 3.02581 17.04 2.92427 17.206 2.85498C17.372 2.78568 17.5501 2.75 17.7299 2.75C17.9098 2.75 18.0879 2.78568 18.2539 2.85498C18.4199 2.92427 18.5705 3.02581 18.6969 3.1537L20.8479 5.3047C20.9758 5.43118 21.0774 5.58177 21.1467 5.74776C21.216 5.91374 21.2516 6.09183 21.2516 6.2717C21.2516 6.45157 21.216 6.62965 21.1467 6.79564C21.0774 6.96163 20.9758 7.11222 20.8479 7.2387L11.3159 16.7707C11.0625 17.0224 10.7202 17.1643 10.3629 17.1657H8.19794C8.019 17.166 7.84178 17.1309 7.67641 17.0626C7.51105 16.9942 7.3608 16.8939 7.23427 16.7674C7.10775 16.6408 7.00743 16.4906 6.93908 16.3252C6.87073 16.1599 6.83568 15.9826 6.83594 15.8037Z",
    stroke: "#0075E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageEdit);
export default __webpack_public_path__ + "static/media/mage_edit.fd555d47289a2926971295b28a3887fa.svg";
export { ForwardRef as ReactComponent };